var map = {
	"./email-field.vue": "qbyV",
	"./file-field.vue": "NWBZ",
	"./input-field.vue": "7ImC",
	"./label-field.vue": "K2/E",
	"./phone-field.vue": "Oxfp",
	"./select-field.vue": "Fedr",
	"./select-group-field.vue": "YpG1",
	"./stage-stamp.vue": "dUkV",
	"./switch-field.vue": "4XD7",
	"./textarea-field.vue": "uiYc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2Cwf";